import { forwardRef, FunctionComponent, Ref, PropsWithoutRef } from 'react';

import { BaseProps, ForwardProps } from '../../types';
import { MenuItemProps } from '../Menu/Menu.types';

import SingleSelectInput from './SingleSelectInput/SingleSelectInput';
import MultiSelectInput from './MultiSelectInput/MultiSelectInput';
import ComboBoxProps, { Selected } from './ComboBox.types';

interface ComboBoxInputProps extends BaseProps {
  mode?: 'multi-select' | 'single-select';
  selected?: Selected | Selected[];
  value?: ComboBoxProps['value'];
  visual?: ComboBoxProps['visual'];
  onRemove?: (id: MenuItemProps['id'], index: number) => void;
}

const ComboBoxInput: FunctionComponent<ComboBoxInputProps & ForwardProps> = forwardRef(
  (props: PropsWithoutRef<ComboBoxInputProps>, ref: Ref<HTMLInputElement>) => {
    const { value, mode, selected, visual, onRemove, ...restProps } = props;

    return mode === 'multi-select' ? (
      <MultiSelectInput
        selected={selected as Selected[]}
        value={value}
        {...{
          ref,
          onRemove
        }}
        {...restProps}
      />
    ) : (
      <SingleSelectInput
        ref={ref}
        selected={selected as Selected}
        value={value}
        visual={visual}
        {...restProps}
      />
    );
  }
);

export default ComboBoxInput;
